export enum CallType {
  Call = 0,
  Callback,
}
